const React = require('react');


/* eslint-disable */
module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`dB fillCT>1 ` + (props.className || '')}
    >
      <path
        d="M19.8998 9.41003L11.4098 17.9L8.58984 17.9L18.4898 8.00002L19.8998 9.41003Z"
      />
      <path
        d="M1.42 8.00002L11.31 17.89L8.49 17.9L-3.7111e-07 9.41003L1.42 8.00002Z"
      />
      <rect
        x="9"
        width="2"
        height="13"
      />
    </svg>
  );
};
